import Grid from "@mui/material/Grid";
import CompanyDetailsCard from "./CompanyDetailsCard";
import CompanyLogotypeCard from "./CompanyLogotypeCard";

export default function CompanySettings(props) {
  return (
    <Grid
      container
      rowSpacing={2}
      columnSpacing={3}
      wrap="nowrap"
      direction={{ xs: "column", md: "row" }}
      justifyContent={{ xs: "flex-start", md: "center" }}
    >
      <Grid>
        <CompanyLogotypeCard />
      </Grid>
      <Grid>
        <CompanyDetailsCard />
      </Grid>
    </Grid>
  );
}
